const isKilled = (pow, hp) => (hp - pow) <= 0;
export default isKilled;
